import { Icon } from '@loadsmart/miranda-react'
import { type ColorToken } from '@loadsmart/miranda-react/dist/tokens'

import { TrackingMethod, type TrackingProvider } from '../../domain/Tracking'
import P44Logo from '../../ui/assets/p44-logo.png'
import TruckerToolsLogo from '../../ui/assets/trucker-tools-logo.png'

const ProvidersIcons = {
  'project-44': <img src={P44Logo} alt="p44" />,
  'trucker-tools': <img src={TruckerToolsLogo} alt="trucker tools" />,
  loadsmart: (
    <Icon name="loadsmart-logo" size="16px" color="color-brand" aria-label="loadsmart icon" />
  ),
}

export function getProviderIcon(provider: TrackingProvider) {
  return ProvidersIcons[provider]
}

export function getMethodIcon(method: TrackingMethod, color: ColorToken = 'color-text-secondary') {
  switch (method) {
    case TrackingMethod.API:
      return <Icon name="code" size="16px" color={color} />
    case TrackingMethod.ELD:
      return <Icon name="truck" size="16px" color={color} />
    case TrackingMethod.Mobile:
      return <Icon name="phone" size="16px" color={color} />
    case TrackingMethod.EDI:
      return <Icon name="plugs" size="16px" color={color} />
    default:
      return <Icon name="hand-tap" size="16px" color={color} />
  }
}
